module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/wechat.3714d4bd.png";